import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { faFilterCircleXmark } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "../Button/Button";
import { ButtonColor, ButtonSize } from "../Button/types";
import { Icon } from "../Icon/Icon";

interface NoResultsFilterWarningProps {
	onSearchWithoutFilters: () => void;
}

/**
 * Shown in a table's empty state when a search query returns no results while
 * filters from the Filters modal are active. Hints that the filters may be the
 * reason and offers to re-run the search using only the query.
 */
export const NoResultsFilterWarning: FunctionComponent<NoResultsFilterWarningProps> = ({
	onSearchWithoutFilters,
}) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col items-center justify-center text-center gap-3 max-w-md mx-auto">
			<Icon className="text-status-warning text-2xl" icon={faFilterCircleXmark} />
			<div className="text-sm text-text-meta">{t("filteredNoResults.message")}</div>
			<Button
				color={ButtonColor.ACTION}
				size={ButtonSize.S}
				title={t("filteredNoResults.searchWithoutFilters")}
				type="button"
				onClick={onSearchWithoutFilters}
			/>
		</div>
	);
};
